var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expand-transition',[(_vm.links)?_c('Iframe',{staticClass:"fill-height fill-width",attrs:{"link":_vm.links.badgeUrl + 'login/forgot-password',"title":"Compte"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }